<app-modal-header [text]="title"></app-modal-header>
<ion-content class="content">
  <p [translate]="text"></p>
</ion-content>
<app-modal-footer [buttons]="buttons"></app-modal-footer>
